var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMallShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7C9.625 4.90188 11.3847 2.84107 13.5722 2.64524C16.1778 2.40279 18.375 4.37036 18.375 6.82283",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42058 10.4819C4.3956 9.53286 5.15813 8.75 6.10749 8.75H21.8925C22.8419 8.75 23.6044 9.53285 23.5794 10.4819L23.3316 19.898C23.2514 22.9459 20.7575 25.375 17.7086 25.375H10.2914C7.24246 25.375 4.74858 22.9459 4.66837 19.898L4.42058 10.4819Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5992 16.9564C16.2529 16.4531 16.6635 15.649 16.6219 14.75C16.5611 13.4265 15.4947 12.3409 14.1733 12.2556C12.6451 12.1575 11.375 13.3679 11.375 14.8748C11.375 15.7226 11.777 16.4755 12.3999 16.9554C12.4841 17.0204 12.5982 17.0279 12.6899 16.9756C13.076 16.7528 13.5228 16.6259 13.9995 16.6259C14.4762 16.6259 14.9241 16.7538 15.3102 16.9756C15.4019 17.0279 15.516 17.0204 15.5992 16.9564Z",
    fill: "#F7DE2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 17.1698C15.5157 17.1047 15.4016 17.0972 15.3099 17.1495C14.9238 17.3724 14.477 17.4993 14.0003 17.4993C13.5236 17.4993 13.0757 17.3713 12.6896 17.1495C12.5979 17.0972 12.4838 17.1047 12.4006 17.1687C11.7458 17.6721 11.3363 18.4772 11.3779 19.3752C11.4398 20.6986 12.5051 21.7853 13.8264 21.8696C15.3547 21.9677 16.6248 20.7573 16.6248 19.2504C16.6248 18.4026 16.2227 17.6497 15.5999 17.1698Z",
    fill: "#F7DE2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMallShopping);
export default __webpack_public_path__ + "static/media/icon_mall_shopping.990dfddb67d3dea2f38f1ca4210de6d1.svg";
export { ForwardRef as ReactComponent };